import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z"
}), 'FirstPageSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FirstPageSharp.js
// module id = 3697
// module chunks = 2